/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { colors, addColor } from "cms/utils/log/colors.js";
import Package from "../../../../package.json";
// import { Config } from '../../../data/config.js'

export const consoleLog = (log, level) => {
    let mlevel;
    if (level === "error") {
        mlevel = addColor(colors.red, `[${log.level}]`);
    } else if (level === "warn") {
        mlevel = addColor(colors.yellow, `[${log.level}]`);
    } else if (level === "info") {
        mlevel = addColor(colors.cyan, `[${log.level}]`);
    } else {
        mlevel = addColor(colors.blue, `[${log.level}]`);
    }
    const mdate = addColor(colors.blackBright,`[${log.dt.toISOString()}]`);
    const mmessage = `${mdate} ${mlevel} ${log.message}`;
    log.location = log.context.url;
    log.message = mmessage;
    console.log(mmessage, { log });
    return log;
};

export const cloudLog = (log, level) => {
    // const mdate = addColor(colors.blackBright,`[${log.dt.toISOString()}]`)
    // let mlevel
    let mmessage;
    if (level === "error") {
        // mlevel = addColor(colors.red, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${addColor(colors.red,`${log.message}`)}`
        mmessage = `${addColor(colors.red,`${log.message}`)}`;
    } else if (level === "warn") {
        // mlevel = addColor(colors.yellow, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${addColor(colors.yellow,log.message)}`
        mmessage = `${addColor(colors.yellow,log.message)}`;
    } else if (level === "info") {
        // mlevel = addColor(colors.cyan, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${log.message}`
        mmessage = `${log.message}`;
    } else {
        // mlevel = addColor(colors.blue, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${log.message}`
        mmessage = `${log.message}`;
    }
    log.location = log?.context?.url;
    log.message = mmessage;
    // console.log(mmessage)
    return log;
};

export const getFilename = (filepath) => {
    return filepath.split(/(\\|\/)/g).pop();
};

// const date_formatted = (date) => {
//     const dateOptions = {
//         weekday: 'long',
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric',
//         hour12: true,
//         hour: 'numeric',
//         minute: '2-digit',
//         second: '2-digit',
//     };
//     date.toLocaleString('en-US', dateOptions)
//     // date.toISOString()
// }

export const getVersion = () => {
    const version  = Package.version;
    return version;
};
